import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '@react-pdf-viewer/core/lib/styles/index.css';
import parse from "html-react-parser";
import DOMPurify from 'dompurify';
import './RichTextRenderer.css'
import { useSearchParams } from 'react-router-dom';
import { useAnalytics } from '../hooks/analytics/useAnalytics';
import { SCREEN_NAMES } from '../constants/analytics';
import { queryRequest } from '../services/internalApi';

export function RichTextRenderer() {
    const [loading, setLoading] = useState(false);
    const [toolData, setToolData] = useState('');
    const { toolId } = useParams();
    const [searchParams] = useSearchParams();
    const userToken = searchParams.get('user_token') || null;

    // ページ表示情報をアナリティクスに送信する
    const analytics = useAnalytics();

    useEffect(() => {

        setLoading(true);
        document.body.classList.add('rich-text-renderer-body');

        const variables = { toolId: parseInt(toolId) };
        if (userToken) {
            variables.userToken = userToken;
        }

        queryRequest(`
            query ($toolId: Int!${userToken ? ', $userToken: String!' : ''}) {
                getHelpfulToolsDetail(
                    toolId: $toolId,
                ) {
                    common {
                        statusCode
                        message
                    }
                    toolData
                }
                ${userToken ? `
                    getMemberIdFromUserToken(userToken: $userToken) {
                        common {
                            statusCode
                            message
                        }
                        memberId
                    }
                ` : ''}
            }
        `, {
            variables: variables
        })
            .then((result) => {
                setLoading(false);
                setToolData(DOMPurify.sanitize(result.data.getHelpfulToolsDetail.toolData));

                const fetchedMemberId = result.data.getMemberIdFromUserToken?.memberId ?? null;

                if(fetchedMemberId !== null) {
                    // ユーザーIDを設定（既に同じIDが設定されている場合はスキップされる）
                    analytics.setAnalyticsUserId(fetchedMemberId);

                    // データ取得完了後にアナリティクスを送信
                    analytics.trackScreenView(SCREEN_NAMES.HELPFUL_TOOLS_DETAIL, {
                        tool_id: toolId,
                    });
                }
            })
            .catch((error) => {
                setLoading(false);
            });
        // マウント時に一度だけ実行する意図的な設計（analyticsはuseMemoで参照が安定しているため省略可）
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {parse(toolData)}
        </>
    )
}